import { Link } from 'react-router-dom'

function DashboardHeader() {
  return (
    <>
      <header className="topbar-nav">
        <nav className="navbar navbar-expand fixed-top bg-white">
          <ul className="navbar-nav mr-auto align-items-center">
            <li className="nav-item page-title">
              <span className="nav-link" href="/">
                <i className="icon-home"></i> Dashboard
              </span>
            </li>

            <li className="nav-item" style={{ display: 'none' }}>
              <a className="nav-link toggle-menu" href="/">
                <i className="icon-menu menu-icon"></i>
              </a>
            </li>
            <li className="nav-item" style={{ display: 'none' }}>
              <form className="search-bar">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter keywords"
                />
                <a href="/">
                  <i className="icon-magnifier"></i>
                </a>
              </form>
            </li>
          </ul>

          <ul className="navbar-nav align-items-center right-nav-link">
            <li className="nav-item dropdown-lg" style={{ display:'none'}}>
              <a
                className="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect"
                data-toggle="dropdown"
                href="/"
              >
                <i className="icon-envelope-open"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right animated fadeIn">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    You have 4 new messages
                    <span className="badge badge-danger">4</span>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <div className="avatar">
                          <img
                            className="align-self-start mr-3"
                            src="http://via.placeholder.com/110x110"
                            alt="user avatar"
                          />
                        </div>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">Jhon Deo</h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet...
                          </p>
                          <small>Today, 4:10 PM</small>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <div className="avatar">
                          <img
                            className="align-self-start mr-3"
                            src="http://via.placeholder.com/110x110"
                            alt="user avatar"
                          />
                        </div>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">Sara Jen</h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet...
                          </p>
                          <small>Yesterday, 8:30 AM</small>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <div className="avatar">
                          <img
                            className="align-self-start mr-3"
                            src="http://via.placeholder.com/110x110"
                            alt="user avatar"
                          />
                        </div>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">Dannish Josh</h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet...
                          </p>
                          <small>5/11/2018, 2:50 PM</small>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <div className="avatar">
                          <img
                            className="align-self-start mr-3"
                            src="http://via.placeholder.com/110x110"
                            alt="user avatar"
                          />
                        </div>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">Katrina Mccoy</h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet.
                          </p>
                          <small>1/11/2018, 2:50 PM</small>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">See All Messages</a>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item dropdown-lg" style={{ display:'none'}}>
              <a
                className="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect"
                data-toggle="dropdown"
                href="/"
              >
                <i className="icon-bell"></i>
                <span className="badge badge-primary badge-up">10</span>
              </a>
              <div className="dropdown-menu dropdown-menu-right animated fadeIn">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    You have 10 Notifications
                    <span className="badge badge-primary">10</span>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <i className="icon-people fa-2x mr-3 text-info"></i>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">
                            New Registered Users
                          </h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet...
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <i className="icon-cup fa-2x mr-3 text-warning"></i>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">
                            New Received Orders
                          </h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet...
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">
                      <div className="media">
                        <i className="icon-bell fa-2x mr-3 text-danger"></i>
                        <div className="media-body">
                          <h6 className="mt-0 msg-title">New Updates</h6>
                          <p className="msg-info">
                            Lorem ipsum dolor sit amet...
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a href="/">See All Notifications</a>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item language" style={{ display: 'none' }}>
              <a
                className="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect"
                data-toggle="dropdown"
                href="/#"
              >
                <i className="flag-icon flag-icon-gb"></i>
              </a>
              <ul className="dropdown-menu dropdown-menu-right animated fadeIn">
                <li className="dropdown-item">
                  {' '}
                  <i className="flag-icon flag-icon-gb mr-2"></i> English
                </li>
                <li className="dropdown-item">
                  {' '}
                  <i className="flag-icon flag-icon-fr mr-2"></i> French
                </li>
                <li className="dropdown-item">
                  {' '}
                  <i className="flag-icon flag-icon-cn mr-2"></i> Chinese
                </li>
                <li className="dropdown-item">
                  {' '}
                  <i className="flag-icon flag-icon-de mr-2"></i> German
                </li>
              </ul>
            </li>
            <li className="nav-item" style={{ display:'none'}}>
              <a
                className="nav-link dropdown-toggle dropdown-toggle-nocaret"
                data-toggle="dropdown"
                href="/#"
              >
                <span className="user-profile">
                  <img
                    src="http://via.placeholder.com/110x110"
                    className="img-circle"
                    alt="user avatar"
                    width="75px"
                    height="75px"
                  />
                </span>
              </a>
              <ul className="dropdown-menu dropdown-menu-right animated fadeIn">
                <li className="dropdown-item user-details">
                  <a href="/">
                    <div className="media">
                      <div className="avatar">
                        <img
                          className="align-self-start mr-3"
                          src="http://via.placeholder.com/110x110"
                          alt="user avatar"
                        />
                      </div>
                      <div className="media-body">
                        <h6 className="mt-2 user-title">Katrina Mccoy</h6>
                        <p className="user-subtitle">katrina92@example.com</p>
                      </div>
                    </div>
                  </a>
                </li>
                <li className="dropdown-divider"></li>
                <li className="dropdown-item">
                  <i className="icon-envelope mr-2"></i> Inbox
                </li>
                <li className="dropdown-divider"></li>
                <li className="dropdown-item">
                  <i className="icon-wallet mr-2"></i> Account
                </li>
                <li className="dropdown-divider"></li>
                <li className="dropdown-item">
                  <i className="icon-settings mr-2"></i> Setting
                </li>
                <li className="dropdown-divider"></li>
                <li className="dropdown-item">
                  <i className="icon-power mr-2"></i> Logout
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>
    </>
  )
}

export default DashboardHeader
